<table mat-table aria-label="tableau vitrine du club" [dataSource]="dataSource" matSort multiTemplateDataRows>

  <ng-container matColumnDef="bookingReference">
    <th mat-header-cell *matHeaderCellDef class="cell_text" mat-sort-header="bookingReference">
      Référence de la facture
    </th>
    <td mat-cell *matCellDef="let element" class="cell_text"> {{element.bookingReference}} </td>
  </ng-container>

  <ng-container matColumnDef="paymentDate">
    <th mat-header-cell *matHeaderCellDef class="cell_text" mat-sort-header="paymentDate">
      Date du paiement
    </th>
    <td mat-cell *matCellDef="let element" class="cell_text"> {{element.paymentDate | date: "shortDate":'UTC'}} </td>
  </ng-container>

  <ng-container matColumnDef="paymentType">
    <th mat-header-cell *matHeaderCellDef class="cell_text" mat-sort-header="paymentType">
      Type de paiement
    </th>
    <td mat-cell *matCellDef="let element" class="cell_text"> {{element.paymentType}} </td>
  </ng-container>

  <ng-container matColumnDef="amount">
    <th mat-header-cell *matHeaderCellDef class="cell_text" mat-sort-header="amount">
      Montant
    </th>
    <td mat-cell *matCellDef="let element" class="cell_text"> {{element.amount}}€ </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns" >
  </tr>
</table>
<mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" [color]="color">
</mat-paginator>
